import { render, staticRenderFns } from "./AzDistributorsTopSlot.vue?vue&type=template&id=5db9afa7"
import script from "./AzDistributorsTopSlot.vue?vue&type=script&lang=js"
export * from "./AzDistributorsTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports